import { render, staticRenderFns } from "./registrationComponent.vue?vue&type=template&id=3b4badda&scoped=true&"
import script from "./registrationComponent.vue?vue&type=script&lang=js&"
export * from "./registrationComponent.vue?vue&type=script&lang=js&"
import style0 from "./registrationComponent.vue?vue&type=style&index=0&id=3b4badda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4badda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
